import React from 'react'

const SvgClownFaceFilled = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M12 22a8 8 0 007.744-10.016A2 2 0 1020 8a2 2 0 10-2-2 2 2 0 10-3.984.256A8.013 8.013 0 0012 6c-.697 0-1.372.089-2.016.256A2 2 0 106 6a2 2 0 10-2 2 2 2 0 10.256 3.984A8 8 0 0012 22zm2-6a2 2 0 11-4 0 2 2 0 014 0zm-4-3l-1-2-1 2 1 2 1-2zm5-2l1 2-1 2-1-2 1-2zm-6.008 6.115a.417.417 0 10-.65.52c1.833 2.293 5.483 2.293 7.317 0a.417.417 0 10-.651-.52c-1.5 1.875-4.516 1.875-6.016 0z'
    />
  </svg>
)

export default SvgClownFaceFilled
